import { createContext, useContext } from 'react'

// Il sito è statico e ogni pagina è un file HTML: il percorso corrente arriva da qui,
// sia nel prerender (percorso della route) sia nel browser (window.location).
const PathnameContext = createContext('/')

export const PathnameProvider = PathnameContext.Provider
export const usePathname = () => useContext(PathnameContext)
